import React from "react";
import {
  Box,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import EarningHistory from "../../EarningHistory";

const EarningsSection = ({ accountId }) => (
  <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      sx={{ p: 2.5 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 850, lineHeight: 1.2 }}>
            Earnings
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Track approved earnings, and payout movement.
          </Typography>
        </Box>
      </Stack>
    </Stack>

    <Divider />

    <Box sx={{ p: 2.5 }}>
      <EarningHistory accountId={accountId} />
    </Box>
  </Paper>
);

export default EarningsSection;
